import React from 'react'
import ProtectedRoute from '../../wrappers/ProtectedRoutes'
import { AdminLayout } from '../../layouts/DashboardLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import DashboardPage from '../../pages/DashboardPage'
import FeaturesRoutes from '../features'

export default function AgentProtectedNav() {
    return (
        <ProtectedRoute allowedRoles={["agent"]}>
            <AdminLayout>
                <Routes>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    {/* Routes pour Support */}
                    <Route path="/*" element={<FeaturesRoutes />} />
                    {/* Redirection par défaut */}
                    <Route path="*" element={<Navigate to="/agent/dashboard" replace />} />
                </Routes>
            </AdminLayout>
        </ProtectedRoute>
    )
}